<template>
  <div class="domain-change-option" v-if="domainName && !isDomainOwnershipVerified">
    <span
      v-html="
        $t('domainActivation.protectDomain.desc.line2.1', {
          domain: domainName,
        })
      "
    />
    <change-domain-link :sourceHook="sourceHook" />
  </div>
</template>

<script>
import ChangeDomainLink from "@/components/ChangeDomainLink/ChangeDomainLink.vue";
import { mapGetters } from "vuex";

export default {
  name: "DomainChangeOption",
  components: {
    ChangeDomainLink,
  },
  props: {
    sourceHook: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      domainName: "domain/domainName",
      isDomainOwnershipVerified: "domain/domainOwnershipVerified",
    }),
  },
};
</script>

<style scoped>
.domain-change-option {
  margin-top: 16px;
  padding: 12px;
  background-color: var(--lightBlueBg3);
  border: 1px solid var(--lightBlueBorder2);
  border-radius: 8px;
  font-size: 14px;
}

.domain-change-option a {
  font-weight: 600;
  text-decoration: underline;
}
</style>
